/**
 * Information about a data source system
 */
export type DeviceTypeDto = 'LvDrive' | 'MvDrive' | 'DcDrive' | 'Drive' | 'Motor' | 'Generator' | 'MotorsAndGenerators' | 'SmartSensor';

export const DeviceTypeDto = {
    LvDrive: 'LvDrive' as DeviceTypeDto,
    MvDrive: 'MvDrive' as DeviceTypeDto,
    DcDrive: 'DcDrive' as DeviceTypeDto,
    Drive: 'Drive' as DeviceTypeDto,
    Motor: 'Motor' as DeviceTypeDto,
    Generator: 'Generator' as DeviceTypeDto,
    MotorsAndGenerators: 'MotorsAndGenerators' as DeviceTypeDto,
    SmartSensor: 'SmartSensor' as DeviceTypeDto,

    GetAvailableTypes(): DeviceTypeDto[] {
        return [this.LvDrive, this.MvDrive, this.DcDrive, this.Drive, this.Motor, this.Generator, this.MotorsAndGenerators, this.SmartSensor];
    }
};